import { useContext } from 'react';

import { FaqItem } from 'components';
import { LocaleContext } from 'components/rebrand/Layout';
import { Link } from 'components/rebrand/Link';

import { IArticleSanityData } from 'typescriptDefs/pages/learn/article';

import { AuthorBio } from './AuthorBio';

type Props = {
  article: IArticleSanityData;
  blogArticleDisclaimer: string[] | undefined;
  isGROQ: boolean;
};

export const ArticleFooter = ({ article, blogArticleDisclaimer, isGROQ }: Props) => {
  const locale = useContext(LocaleContext);
  return (
    <>
      <div>
        {!article.removeDisclaimer &&
          blogArticleDisclaimer &&
          blogArticleDisclaimer.length > 0 &&
          blogArticleDisclaimer.map((textblock, i) => (
            <span key={i} dangerouslySetInnerHTML={{ __html: textblock }} className="mb-32 text-lg text-grey-400" />
          ))}
      </div>

      <div className="mt-48 border-t border-grey-75 pt-24">
        {article.authorData.img && article.authorData.bio && (
          <AuthorBio
            img={article.authorData.img}
            bio={article.authorData.bio}
            name={article.authorData.name}
            slug={article.authorData.slug}
            isGROQ={isGROQ}
          />
        )}
      </div>

      {article.sources && article.sources.length > 0 && (
        <FaqItem
          styleBtn="py-0 w-full sm:w-auto"
          styleFaqItemContent="py-0"
          styleTitle="text-xl md:text-3xl leading-140 font-medium"
          className="mb-0 border-b-0"
          title={{ en: 'Sources', fr: 'Références' }[locale]}
        >
          <ul>
            {article.sources.map((source, i) => (
              <li key={i} className="[&:not(:last-of-type):mb-16">
                <p dangerouslySetInnerHTML={{ __html: source.source }} className="mb-8" />
                <Link
                  href={source.link}
                  className="min-h-[1.5em] break-words text-md font-normal leading-normal text-blue md:text-lg [&>*:last-child]:mb-0"
                >
                  {source.link}
                </Link>
              </li>
            ))}
          </ul>
        </FaqItem>
      )}
    </>
  );
};
